function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { DisplayComponent } from "~/components/newsletter/newsletter-widget/enums";
import { StyledSignUpNewsletter } from "~/components/newsletter/newsletter-widget/styles";
export const useArticleRender = onSuccess => ({
  [DisplayComponent.SignUpNewsletter]: props => /*#__PURE__*/React.createElement(StyledSignUpNewsletter, _extends({
    isShowOverlaySignUp: true,
    onSuccess: onSuccess
  }, props))
});